import axios from "axios";
import moment from "moment";
import { getXRFHeaderValue } from "../utils/getXRFHeaderValue";
const xaFormat = "DD-MM-YYYY";

class MatrixService {
  getMetrics(dateRange, site) {
    const dateFrom = moment(dateRange.start).format(xaFormat);
    const dateTo = moment(dateRange.end).format(xaFormat);
    const dimensionId = process.env.REACT_APP_PAGE_MATRIX_DIMENSION;
    console.log("using dimension " + dimensionId);
    if (!dimensionId) {
      throw "dimension id cannot be resolved";
    }

    const byPageUrlServiceUri = `/sitecore/api/ao/aggregates/${site}/${dimensionId}/all?&dateGrouping=collapsed&dateFrom=${dateFrom}&dateTo=${dateTo}&keyGrouping=by-key`;

    const options = {
      headers: {
        "content-type": "application/json",
        "X-RequestVerificationToken": getXRFHeaderValue(),
        "X-Requested-With": "XMLHttpRequest"
      },
      withCredentials: true
    };

    return axios
      .get(byPageUrlServiceUri, options)
      .then(res => {
        const response = res.data;
        response.id = "pageviews";
        //response.data = this.filter(filters, res.data);
        return response;
      })
      .catch(error => console.log(error));
  }
}

export default new MatrixService();



// WEBPACK FOOTER //
// ./src/data/MatrixService.prod.js